<div class="annuity-tabs" role="tablist">
  <!-- Tabs -->
  <div class="tab-header">
    <button
      *ngFor="let tab of tabs"
      type="button"
      [class.active]="tab.isActive"
      (click)="selectTab(tab.title)"
      class="tab-button"
      role="button"
      [attr.aria-selected]="tab.isActive"
      [attr.aria-label]="'Tab ' + tab.title + ' ' + (tab.isActive ? '(active)' : '')"
      [attr.aria-controls]="'section-' + tab.title"
      [id]="'tab-' + tab.title"
    >
      {{ tab.title }}
    </button>
  </div>
  <!-- Sub Tabs -->
  <div class="view-toggle" role="toolbar" aria-label="View Toggle">
    <button
      type="button"
      *ngFor="let subTab of subTabs; index as i"
      [class.active]="subTab.isActive"
      (click)="setView(subTab.subTitle)"
      role="button"
      [attr.aria-pressed]="subTab.isActive"
    >
      {{ subTab.subTitle }}
    </button>
  </div>

  <!-- Skeleton loader while loading -->
  <div [ngClass]="{ 'products-loader': isLoading }">
    <ng-container *ngIf="isLoading; else productContent">
      <app-skeleton-line></app-skeleton-line>
      <app-skeleton-line width="80%"></app-skeleton-line>
      <app-skeleton-line width="60%"></app-skeleton-line>
      <app-skeleton-line width="90%"></app-skeleton-line>
    </ng-container>
  </div>

  <!-- Tab content -->
  <ng-template #productContent>
    <div class="sections-container">
      <div
        class="section"
        *ngFor="let section of sections"
        [attr.id]="'section-' + section.name"
        role="tabpanel"
        [attr.aria-label]="'tab-' + section.name"
      >
        <h2 class="section-title">{{ section.name }}</h2>
        <ul class="link-list" role="list" [attr.aria-label]="'List of links for ' + section.name">
          <li *ngFor="let link of section.items">
            <a
              *ngIf="link.url.includes(curentDomin); else externalLink"
              (click)="navigateToUrl(link.url.replace(curentDomin, ''), link.target)"
              class="link-item"
              role="link"
              [attr.aria-label]="link.text"
            >
              <span>{{ link.text }}</span>
              <div class="underline" aria-hidden="true"></div>
            </a>
            <ng-template #externalLink>
              <a
                [href]="link.url"
                [target]="link.target"
                class="link-item"
                role="link"
                [attr.aria-label]="link.text + (link.url.endsWith('.pdf') ? ' (PDF file)' : '')"
              >
                <span>{{ link.text }}</span>
                <span style="display: none" *ngIf="link.url.endsWith('.pdf')" class="sr-only">(PDF file)</span>
                <div class="underline" aria-hidden="true"></div>
              </a>
            </ng-template>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</div>
